import { Box, Typography } from '@mui/material';

import { isMac } from 'appUtils';
import FontAwesomeIcon from 'features/common/FontAwesomeIcon';

import styles from './Map.module.css';

export default function UndoSpan() {
  return (
    <Box className={styles.undoSpan}>
      <FontAwesomeIcon name="rotate-left" size="0.75rem" gold />
      <Typography className={styles.undoLabel} variant="caption">
        Undo ({isMac ? 'Cmd' : 'Ctrl'} + Z)
      </Typography>
    </Box>
  );
}
